package com.neurobs.js.ccab

import com.neurobs.ccab.ObjectResult
import com.neurobs.ccab.db.EventData
import com.neurobs.js.http
import com.neurobs.util.JsonPrinter.jsonPrint
import io.circe.generic.auto._

object LogServer {

  def getS3SyncStartEvents(onComplete: http.ServerObjectResponse[ObjectResult[Seq[EventData]]] => Unit) = {
    http.getServerObjectAsync[ObjectResult[Seq[EventData]]](
      url = "/api/v1/s3sync/events/start_events",
      t = http.HTTPRequestType.Get
    )(onComplete)
  }

  def getS3SyncEventsFromStart(startEventId: Long)(onComplete: http.ServerObjectResponse[ObjectResult[Seq[EventData]]] => Unit) = {
    http.getServerObjectAsync(
      url = s"/api/v1/s3sync/events/sync_events/$startEventId",
      t = http.HTTPRequestType.Get
    )(onComplete)
  }
}
